import { initializeApp, getApps } from "firebase/app";
import "firebase/auth";

const config = {
	apiKey: process.env.REACT_APP_API_KEY,
	authDomain: process.env.REACT_APP_AUTH_DOMAIN,
	projectId: process.env.REACT_APP_PROJECT_ID,
	storageBucket: process.env.REACT_APP_STORAGE_BUCKET,
	messagingSenderId: process.env.REACT_APP_MESSAGING_SENDER_ID
};
// console.log(config);
let app;

if (!getApps().length) {
	app = initializeApp(config);
}

export default app;
